import { cn } from "@/lib/utils";

interface ProgressDotsProps {
  className?: string;
  "aria-label"?: string;
}

// A compact three-dot bouncing indicator that inherits color from `text-current`.
// Used in place of spinner+text pending states inside buttons.
export function ProgressDots({ className, "aria-label": ariaLabel }: ProgressDotsProps) {
  return (
    <span
      role="status"
      aria-label={ariaLabel ?? "Cargando"}
      className={cn("inline-flex items-center gap-0.5", className)}
    >
      <span className="size-1 animate-[progress-dots_0.9s_ease-in-out_infinite] rounded-full bg-current motion-reduce:animate-none" />
      <span className="size-1 animate-[progress-dots_0.9s_ease-in-out_0.15s_infinite] rounded-full bg-current motion-reduce:animate-none" />
      <span className="size-1 animate-[progress-dots_0.9s_ease-in-out_0.3s_infinite] rounded-full bg-current motion-reduce:animate-none" />
    </span>
  );
}
